import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resAbout {
  message: string;
  success: boolean;
  result: [
    {
      ID: number,
      NAME: string,
      IMAGE_NAME: string
    }

  ]
}

@Injectable({
  providedIn: 'root'
})
export class AboutService {
  token: string = null;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  about() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resAbout>(environment.URL + '/about/about', { headers });
  }

}
